import { h } from "hyperapp";

import { Categories } from "../../common/categories/main";
import { mainTooltip } from "../../common/main-tooltip/main-tooltip";
import { Portifolios } from "../../common/portifolios/main";

import controlsCSS from "./controls.css";
import { NearPlaces } from "./near-places";

export const controls = ({
  translations,
  actions: {
    fetchCategories,
    fetchUnvisitedPlaces,
    fetchUnvisitedPlacesNearby,
    setSince,
    setUntil,
    setCategory,
    fetchPortifolios,
    setPortifolio,
    setPagination,
    setHasSelectedPlace,
    setSelectedPlace,
    setRadius,
  },
  section,
  state: {
    categories = [],
    categoryID,
    clientID,
    loadingCategories,
    loadingPortifolios,
    loadingUnvisitedPlaces,
    pageNumber,
    pageSize,
    portifolioID,
    portifolios = [],
    since,
    until,
    hasSelectedAPlace,
    selectedPlace,
    radius,
  },
  basePageSize,
  initialPageSize,
}): JSX.Element => {
  return (
    <form
      onsubmit={event => {
        event.preventDefault(),
          setPagination({
            pageSize: pageSize === initialPageSize ? basePageSize : pageSize,
            section,
          });

        if (!hasSelectedAPlace) {
          fetchUnvisitedPlaces({
            categoryID,
            clientID,
            pageNumber,
            pageSize,
            portifolioID,
            since,
            until,
          });
          return;
        }
        fetchUnvisitedPlacesNearby({
          categoryID,
          clientID,
          coordinates: selectedPlace.coordinates,
          pageNumber,
          pageSize,
          radius,
          since,
          until,
        });
      }}
    >
      <div class="align-items-start justify-content-start align-items-md-end justify-content-md-end d-flex flex-column flex-md-row flex-lg-column">
        <div class="col-12 col-md-4 col-lg-12 d-md-inline-block mb-3 p-0 pr-md-2 pr-lg-0">
          <div className="row">
            <div className="col-12 mb-2">
              <div className="d-flex align-items-center  mb-2">
                <label class={controlsCSS.dateInputWrapper} for="since">
                  {translations["since"]}
                  <span style="color:red;">*</span>
                </label>
                {mainTooltip({
                  text: translations["unvisitedPlacesTooltipText"],
                  link:
                    "https://help.contele.io/pt-br/knowledge/locais-nao-visitados",
                })}
              </div>
              <input
                class="form-control"
                disabled={loadingUnvisitedPlaces}
                id="since"
                max={new Date(Date.now()).toISOString().substring(0, 10)}
                onchange={event => setSince({ since: event.target.value })}
                required
                type="date"
                value={since}
              />
            </div>
            <br />

            <div className="col-12">
              <div className="d-flex align-items-center  mb-2">
                <label class={controlsCSS.dateInputWrapper} for="until">
                  {translations["until"]}{" "}
                </label>
                {mainTooltip({
                  text: translations["explainFilterTooltipText"],
                })}
              </div>
              <input
                class="form-control"
                disabled={loadingUnvisitedPlaces}
                id="until"
                max={new Date(Date.now()).toISOString().substring(0, 10)}
                onchange={event => setUntil({ until: event.target.value })}
                required
                type="date"
                value={until}
              />
            </div>
          </div>
        </div>
        {Categories({
          actions: { setCategory, fetchCategories },
          translations,
          section,
          state: {
            categories,
            categoryID,
            clientID,
            disabled: loadingUnvisitedPlaces,
            loading: loadingCategories,
          },
        })}
        {Portifolios({
          translations,
          actions: { setPortifolio, fetchPortifolios },
          section,
          state: {
            clientID,
            disabled: loadingUnvisitedPlaces,
            loading: loadingPortifolios,
            portifolioID,
            portifolios,
          },
        })}

        {NearPlaces({
          translations,
          actions: {
            setPortifolio,
            fetchPortifolios,
            setHasSelectedPlace,
            setSelectedPlace,
            setRadius,
            fetchUnvisitedPlaces,
          },
          section,
          state: {
            clientID,
            disabled: loadingUnvisitedPlaces,
            loading: loadingPortifolios,
            portifolioID,
            portifolios,
            hasSelectedAPlace,
            selectedPlace,
            radius,
          },
        })}

        <div class="col-12 col-md-4 col-lg-12 d-md-inline-block mb-3 p-0 pl-md-2 pl-lg-0">
          <button
            style="background-color:#1A69AD; color:white"
            class="btn btn-sm  pl-5 pr-5"
            disabled={loadingUnvisitedPlaces}
            type="submit"
          >
            Filtrar
          </button>
        </div>
      </div>
    </form>
  );
};
